
const statuses = Object.freeze({
    ACTIVE : "active",
    IN_ACTIVE : "inactive"
});

export default statuses;